module.exports = __webpack_public_path__ + "img/huixian.696db603.png";